import * as React from "react";

interface InputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  maxLength?: number;
  isTextarea?: boolean;
  rows?: number;
  variant?: "default" | "specs"; // Adăugăm varianta
}

const Input: React.FC<InputProps> = ({
  value,
  onChange,
  placeholder,
  maxLength,
  isTextarea = false,
  rows = 5,
  variant = "default", // Setăm "default" ca valoare implicită pentru variantă
}) => {
  const commonProps = {
    value,
    onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
      onChange(e.target.value),
    placeholder,
    maxLength,
    className: `w-full ${
      variant === "specs"
        ? "p-2 border border-gray-300 rounded-lg font-ubuntu text-primary"
        : "p-4 border border-gray-300 rounded-lg font-ubuntu text-primary"
    }`,
  };

  return (
    <div className="">
      {isTextarea ? (
        <textarea {...commonProps} rows={rows} />
      ) : (
        <input type="text" {...commonProps} />
      )}
      {maxLength && (
        <div className="text-right text-sm text-gray-500">
          {value.length}/{maxLength}
        </div>
      )}
    </div>
  );
};

export default Input;
